import { connect } from 'react-redux';
import { clearScrollTo } from '../../actions/scrollActions';
import ScrollManager from './ScrollManager';

export default connect(
  state => ({
    scrollTo: state.view.components.scrollManager.scrollTo,
    fixedHeaderElements: state.view.components.scrollManager.fixedHeaderElements,
  }),
  {
    clearScrollTo,
  },
)(ScrollManager);
